import { useState } from "react";
import { testimonialsData } from "@/mocks/homeData";

export default function TestimonialsSection() {
  const [activeIndex, setActiveIndex] = useState(0);
  const testimonial = testimonialsData.testimonials[activeIndex];

  return (
    <section id="testimonials" className="w-full py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="text-center max-w-2xl mx-auto mb-10 md:mb-14">
          <span className="text-sm font-semibold text-primary-500 uppercase tracking-wider">
            Client Stories
          </span>
          <h2 className="font-heading font-bold text-2xl md:text-3xl lg:text-4xl text-foreground-950 mt-2 mb-4">
            {testimonialsData.headline}
          </h2>
          <p className="text-foreground-700 leading-relaxed">
            {testimonialsData.subheadline}
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="bg-background-100 rounded-xl p-6 md:p-10 border border-background-200/70 text-center">
            <div className="flex justify-center gap-1 mb-6">
              {[1, 2, 3, 4, 5].map((star) => (
                <i
                  key={star}
                  className="ri-star-fill text-accent-500 text-lg"
                />
              ))}
            </div>

            <blockquote className="font-heading text-lg md:text-xl lg:text-2xl text-foreground-900 leading-relaxed mb-8">
              &ldquo;{testimonial.quote}&rdquo;
            </blockquote>

            <div className="flex items-center justify-center gap-3">
              <div className="w-10 h-10 md:w-12 md:h-12 rounded-full bg-primary-100 flex items-center justify-center">
                <span className="font-heading font-semibold text-primary-600 text-sm md:text-base">
                  {testimonial.author
                    .split(" ")
                    .map((n) => n[0])
                    .join("")}
                </span>
              </div>
              <div className="text-left">
                <div className="font-semibold text-foreground-950 text-sm md:text-base">
                  {testimonial.author}
                </div>
                <div className="text-xs md:text-sm text-foreground-600">
                  {testimonial.role}, {testimonial.company}
                </div>
              </div>
            </div>
          </div>

          <div className="flex justify-center gap-2 mt-6">
            {testimonialsData.testimonials.map((_, idx) => (
              <button
                key={idx}
                onClick={() => setActiveIndex(idx)}
                className={`w-2.5 h-2.5 rounded-full transition-all cursor-pointer ${
                  idx === activeIndex
                    ? "bg-primary-500 w-6"
                    : "bg-background-300 hover:bg-background-400"
                }`}
                aria-label={`Go to testimonial ${idx + 1}`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}